import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { CurrentUserVisibilityRuleAccess, CurrentUserVisibilityRuleKey, VisibilityRule, VisibilityRulesKey } from '../@types/visibilityRule.type';
import { getCurrentUserVisibility, getVisibilityRuleById, getVisibilityRules } from '../api/visibilityRules';

export const useGetVisibilityRules = (): UseQueryResult<VisibilityRule[]> => {
  return useQuery({
    queryKey: [VisibilityRulesKey],
    queryFn: () => getVisibilityRules(),
    staleTime: 5 * 60 * 60 * 1000
  });
};

export const useGetOneVisibilityRule = (id: number): UseQueryResult<VisibilityRule> => {
  return useQuery({
    queryKey: [VisibilityRulesKey, id],
    queryFn: () => getVisibilityRuleById(id),
    staleTime: 5 * 60 * 60 * 1000
  });
};

export const useGetCurrentUserVisibility = (): UseQueryResult<CurrentUserVisibilityRuleAccess> => {
  return useQuery({
    queryKey: [CurrentUserVisibilityRuleKey],
    queryFn: () => getCurrentUserVisibility(),
    staleTime: 5 * 60 * 60 * 1000
  });
};